export default "__VITE_ASSET__ecW3VYbS__"